import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql, Link } from "gatsby";
import { Wrapper, Main, FooterDiv } from "./elements";

import Header from "./../Header";

const Layout = ({ children, darkBackdrop, isHome }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);
  return (
    <React.Fragment>
      <Header
        siteTitle={data.site.siteMetadata.title || "Seaways & Gatekeepers"}
        isHome={isHome || false}
      />
      <Wrapper>
        <Main darkBackdrop={darkBackdrop}>{children}</Main>
      </Wrapper>
      <FooterDiv>
        <p>
          © {new Date().getFullYear()}{" "}
          <a href="https://nuspress.nus.edu.sg">NUS Press</a>.{" "}
          <Link to={`/privacy-policy`}>Privacy policy</Link>
        </p>
      </FooterDiv>
    </React.Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
